'use client';

import { createContext, useContext, type ReactNode } from 'react';

const EditorReadOnlyContext = createContext(false);

/** Scope configuration forms, never Preview. Nested forms cannot unlock a parent. */
export function EditorReadOnlyProvider({ readOnly = false, children }: {
  readOnly?: boolean;
  children: ReactNode;
}) {
  const inherited = useContext(EditorReadOnlyContext);
  return <EditorReadOnlyContext.Provider value={inherited || readOnly}>{children}</EditorReadOnlyContext.Provider>;
}

export function useEditorReadOnly(readOnly = false) {
  return useContext(EditorReadOnlyContext) || readOnly;
}
